"use strict";

exports.__esModule = true;
exports.default = publishReplayLatestWhileConnected;

var _wmelonRxShim = require("../__wmelonRxShim");

function publishReplayLatestWhileConnected(source) {
  return source.pipe((0, _wmelonRxShim.multicast)(function () {
    return new _wmelonRxShim.ReplaySubject(1);
  }));
}